/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ClinicalNotesInstitutionStandardTextAliases {
  ACCEPT_CUSTOM_DYNAMIC_BUTTON = 'accept-custom-dynamic-button',
  AUTOC_CLINICAL_NOTES_TYPE = 'autoc-clinical-notes-type',
  AUTOC_MEDICAL_SPECIALTY = 'autoc-medical-specialty',
  AUTOC_STANDARD_TEXT = 'autoc-standard-text',
  AUTOC_STANDARD_TEXT_GROUP = 'autoc-standard-text-group',
  CHECKBOX_CLICNICAL_NOTES_MSG = 'checkbox-clicnical-notes-msg',
  FETCH_CLINICAL_NOTES_TYPE = 'fetch-clinical-notes-type',
  FETCH_MEDICAL_SPECIALTY = 'fetch-medical-specialty',
  FETCH_STANDARD_TEXT = 'fetch-standard-text',
  FETCH_STANDARD_TEXT_GROUP = 'fetch-standard-text-group',
  FIELD_CLICNICAL_NOTES_MSG = 'field-clicnical-notes-msg',
  FIELD_CLINICAL_NOTES_TYPE = 'field-clinical-notes-type',
  FIELD_MEDICAL_SPECIALTY = 'field-medical-specialty',
  FIELD_STANDARD_TEXT = 'field-standard-text',
  FIELD_STANDARD_TEXT_GROUP = 'field-standard-text-group',
  FORM_STANDARD_TEXT = 'form-standard-text',
  GLOBAL_ACTIONS = 'global-actions',
  LAYOUT_INSTITUTION_STANDARD_TEXT = 'layout-institution-standard-text',
  LOADER_REPLACED_TEXT = 'loader-replaced-text',
  MAPPER_CLINICAL_NOTES_TYPE = 'mapper-clinical-notes-type',
  MAPPER_MEDICAL_SPECIALTY = 'mapper-medical-specialty',
  MAPPER_STANDARD_TEXT = 'mapper-standard-text',
  MAPPER_STANDARD_TEXT_GROUP = 'mapper-standard-text-group',
  MODAL_INSTITUTION_STANDARD_TEXT = 'modal-institution-standard-text',
  PANEL_ACCEPT = 'panel-accept',
  PANEL_ACTIONS = 'panel-actions',
  PANEL_LOADER = 'panel-loader',
  PANEL_MESSAGE_ACCEPT = 'panel-message-accept',
  STANDARD_TEXT_BUTTON_CANCEL = 'standard-text-button-cancel',
  STANDARD_TEXT_BUTTON_OK = 'standard-text-button-ok',
  TEXT_CLINICAL_NOTES_TYPE = 'text-clinical-notes-type',
  TEXT_MEDICAL_SPECIALTY = 'text-medical-specialty',
  TEXT_MESSAGE_ACCEPT = 'text-message-accept',
  TEXT_STANDARD_TEXT = 'text-standard-text',
  TEXT_STANDARD_TEXT_GROUP = 'text-standard-text-group',
}
export { ClinicalNotesInstitutionStandardTextAliases };
